import moment from 'moment';
import { useState } from 'react';

import { colors } from '@tempmee/tailwind';
import { CollapsibleRow } from '../../CollapsibleRow/CollapsibleRow';
import { Title } from '../../CollapsibleRow/Title';
import { DateContent } from './DateContent';
import { SolidCalendarIcon } from '@tempmee/react-icons';

export const SingleDateRow = ({ defaultValue, onToggle, isOpen, onConfirm }) => {
  const [selectedDate, setSelectedDate] = useState(defaultValue);

  const handleConfirmDates = (dates) => {
    setSelectedDate(dates[0]);
    onConfirm(dates[0]);
    onToggle();
  };

  return (
    <>
      <CollapsibleRow
        isOpen={isOpen}
        onToggle={onToggle}
        showArrow
        TitleComponent={() => <Title text="Date:" />}
        titlePosition="flex-start"
        ValueComponent={() => (
          <span
            style={{
              fontFamily: 'Nunito',
              color: colors.neutral[600],
              textTransform: 'capitalize',
            }}
          >
            {selectedDate && moment(selectedDate).format('ddd, MMM DD, YYYY')}
          </span>
        )}
        icon={<SolidCalendarIcon size={24} color={colors.secondary[500]} />}
      >
        <DateContent
          maxDaysToSelect={1}
          onConfirm={handleConfirmDates}
          defaultValues={[defaultValue]}
        />
      </CollapsibleRow>
    </>
  );
};
